import { useState } from 'react';
import { Box, Center, Collapse, Text, VStack, Spinner } from '@chakra-ui/react';
import Dropzone from 'react-dropzone';
import { uploadPedidoFile } from '../services/pedidos';
import { uploadEncargoFile } from '../services/encargos';
import { okNotification } from '../utils/Notificaciones';

const UploadComponent = ({
	uuid,
	esPedido,
	toast,
	mostrarSubirDocumento,
	setMostrarSubirDocumento,
}) => {
	const [uploadFiles, setUploadFiles] = useState([]);

	const handleFileSelect = async acceptedFiles => {
		// Crear estado inicial de cada archivo
		const newFiles = acceptedFiles.map(file => ({
			file,
			status: 'pending', // "pending" | "uploading" | "success" | "error"
		}));
		setUploadFiles(prev => [...prev, ...newFiles]);

		// Iterar y subir uno por uno
		for (let i = 0; i < acceptedFiles.length; i++) {
			const file = acceptedFiles[i];

			setUploadFiles(prev =>
				prev.map(f =>
					f.file === file ? { ...f, status: 'uploading' } : f,
				),
			);

			try {
				const reader = new FileReader();

				await new Promise((resolve, reject) => {
					reader.onload = async () => {
						try {
							const datos = reader.result.split(',')[1];

							if (esPedido) {
								await uploadPedidoFile(uuid, file.name, datos);
							} else {
								await uploadEncargoFile(uuid, file.name, datos);
							}

							setUploadFiles(prev =>
								prev.map(f =>
									f.file === file
										? { ...f, status: 'success' }
										: f,
								),
							);
							resolve();
						} catch (err) {
							setUploadFiles(prev =>
								prev.map(f =>
									f.file === file
										? { ...f, status: 'error' }
										: f,
								),
							);
							reject(err);
						}
					};

					reader.onerror = () => {
						setUploadFiles(prev =>
							prev.map(f =>
								f.file === file ? { ...f, status: 'error' } : f,
							),
						);
						reject(reader.error);
					};

					reader.readAsDataURL(file);
				});
			} catch (err) {
				console.error('❌ Error subiendo archivo:', file.name, err);
			}
		}

		// Si todos los archivos están en success
		if (
			uploadFiles.length > 0 &&
			uploadFiles.every(f => f.status === 'success')
		) {
			okNotification(
				'Todos los documentos se subieron correctamente',
				toast,
			);
			setMostrarSubirDocumento(false);
			// setUploadFiles([]); // Limpiar estado de archivos subidos
		}
	};

	return (
		<Collapse in={mostrarSubirDocumento} animateOpacity>
			<Center
				p={4}
				my={4}
				border='1px solid black'
				bgColor='blackAlpha.100'
				rounded='md'
				flexDirection='column'
			>
				<Dropzone onDrop={handleFileSelect} multiple>
					{({ getRootProps, getInputProps }) => (
						<Box {...getRootProps()} cursor='pointer'>
							<input {...getInputProps()} />
							<Text mb={2}>
								<strong>Arrastra y suelta</strong> uno o más
								archivos aquí o{' '}
								<strong>haz clic para seleccionarlos.</strong>
							</Text>
						</Box>
					)}
				</Dropzone>

				{/* Mostrar progreso de archivos */}
				<VStack spacing={3} mt={4} width='100%'>
					{uploadFiles.map(({ file, status }, idx) => (
						<Box
							key={idx}
							width='100%'
							p={2}
							borderRadius='md'
							bg='white'
							boxShadow='sm'
							display='flex'
							alignItems='center'
							justifyContent='space-between'
						>
							<Text fontSize='sm' isTruncated maxW='70%'>
								📄 {file.name}
							</Text>
							{status === 'pending' && (
								<Text color='gray.500'>Pendiente</Text>
							)}
							{status === 'uploading' && (
								<Spinner size='sm' color='blue.500' />
							)}
							{status === 'success' && (
								<Text color='green.500'>✔️ Subido</Text>
							)}
							{status === 'error' && (
								<Text color='red.500'>❌ Error</Text>
							)}
						</Box>
					))}
				</VStack>
			</Center>
		</Collapse>
	);
};

export default UploadComponent;
